<template>
  <v-container fluid class="claim-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/claim/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
              <v-btn color="primary" class="button-shadow mr-3" @click="makeReimbursementList">
                <v-icon class="mr-2">mdi-cash-plus</v-icon>
                Reimburse
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="claims-table"
              show-select
              v-model="dataSelected"
              item-key="_id"
              sort-desc
              sort-by="claimnum"
              :footer-props="footer"
              :headers="headers"
              :items="data_claims"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Claim?
                    </v-card-title>
                    <v-card-text>
                      {{ deleteclaim.claimnum }} 
                      {{ deleteclaim.claimname }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deleteclaim)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.employeeid="{ item }">
                <v-avatar v-if="employees.length>0 && employees.find(employee=>employee._id == item.employeeid)['employeeimage']!==''" size="40">
                  <img v-bind:src="employees.find(employee=>employee._id == item.employeeid)['employeeimage']" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="40">
                  <span class="white--text headline">{{ employees.length>0 ? employees.find(employee=>employee._id == item.employeeid)['employeename'][0].toUpperCase() : '' }}</span>
                </v-avatar>
                <span style="margin-left:15px">{{ employees.length>0 ? employees.find(employee=>employee._id == item.employeeid)['employeename'] : '' }} </span>
              </template>
              <template v-slot:item.claimnum="{ item }">
                <p class="two-line">{{ item.claimtype  }}</p>
                <p class="two-line">{{ item.claimnum  }}</p>
                <p class="two-line">{{ new Date(item.claimdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</p>
              </template>
              <template v-slot:item.claimaddress="{ item }">
                <p class="two-line">{{ item.claimaddress }}</p>
              </template>
              <template v-slot:item.claimtotal="{ item }">
                {{ item.claimtotal.toLocaleString('en-SG') }}
              </template>
              <template v-slot:item.claimstatus="{ item }">
                <v-chip
                  :color="item.claimstatus=='Approve' ? 'successConst white--text' : item.claimstatus=='Reject' ? 'error white--text' : item.claimstatus=='Completed' ? 'greyTint white--text' : 'primaryConst white--text'"
                  small>
                  {{ item.claimstatus }}
                </v-chip>
                <p class="two-line" style="font-size: x-small;">{{ item.claimreason }}</p>
              </template>
              <template v-slot:item.claimtotal="{ item }">
                {{ item.claimtotal!=null ? item.claimtotal.toFixed(2) : '' }}
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="viewItem(item)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn v-if="item.claimstatus=='New'" icon color="primary" @click="editClaimStatusDialog(item)">
                  <v-icon>mdi-text-box-edit-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="printItem(item)">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
                <v-btn v-if="item.claimstatus=='New'" icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-dialog
      v-model="showEditDialog"
      persistent
      width="400px"
      max-width="400px"
      >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Status</span>
        </v-card-title>
          <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="12">
                <v-select
                  :items="statuses"
                  v-model="claimstatus.claimstatus"
                  v-bind:error="errorindex == 11"
                  label="Status"
                  required
                ></v-select>
              </v-col>
                <v-col cols="12" md="12">
                <v-text-field
                  v-model="claimstatus.claimreason"
                  v-bind:error="errorindex == 12"
                  :label="claimstatus.claimstatus=='Approve' || claimstatus.claimstatus=='Reject' ? claimstatus.claimstatus + ' Reason' : 'Reason'"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="showEditDialog = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="editClaimStatus"
            >
              Save
            </v-btn>
          </v-card-actions>
         
      </v-card>
      </v-dialog>
    </v-row>
    <div class="text-center">
    <v-dialog
      v-model="dialogAlert"
      width="300"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">Error</v-card-title>
        <v-card-text>
          {{ dialogMessage }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialogAlert = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  </v-container>
</template>

<script>
import config from "../../../../config"
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ClaimHrmList',
  data() {
    return {
      config,
      dialog: false,
      dialogAlert: false,
      dialogMessage: '',
      showEditDialog: false,
      error: undefined,
      haserror: false,
      errorindex: undefined,
      itemPerPage: 500,
      deleteclaim: {},
      claimstatus: {},
      footer: {'items-per-page-options': [500, 1000, 5000]},
      headers: [
        { text: 'Claim', value: 'claimnum', sortable: false },
        { text: 'Name', value: 'claimname' },
        { text: 'Amount', value: 'claimtotal' },
        { text: 'Employee', value: 'employeeid' },
        { text: 'Status', value: 'claimstatus', align: 'center', 'width': '10%' },
        { text: 'Actions', value: 'actions', sortable: false, 'width': '15%' },
      ],
      statuses: ["Approve", "Reject"],
      dataSelected: [],
      data_claims: [],
    }
  },
  computed: {
    ...mapState('Claim', ['claims', 'isReceiving', 'isDeleting', 'isUpdating']),
    ...mapState('Employee', ['employees']),
  },
  async created () {
    await this.getClaimsRequest();
    this.data_claims = Object.assign([], this.claims.filter(claim=>(claim.claimtype=='Medical Claim' && (claim.claimstatus=='Approve' || claim.claimstatus=='Completed')) || (claim.claimtype=='Expense Claim')));
    
    if(this.employees.length==0) await this.getEmployeesRequest();
  },
  methods: {
    ...mapActions('Region', ["getRegionsRequest"]),
    ...mapActions('Township', ["getTownshipsRequest"]),
    ...mapActions('Claim', ["getClaimsRequest","deleteClaimRequest","updateClaimStatusRequest","createClaimRequest"]),
    ...mapActions('Employee', ["getEmployeesRequest"]),
    checkError(){
      if(this.dataSelected.length==0) return false;
      if(this.dataSelected.find(item=>item.claimstatus=='New')!=null) return false;
      else if(this.dataSelected.find(item=>item.claimstatus=='Reject')!=null) return false;
      else if(this.dataSelected.find(item=>item.claimstatus=='Completed')!=null) return false;
      return true;
    },
    checkError1(){
      if(!this.claimstatus.claimstatus){
        this.haserrors = true;
        this.errorindex = 11;
        return false;
      }
      if(!this.claimstatus.claimreason){
        this.haserrors = true;
        this.errorindex = 12;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    checkClaims(){
      return this.dataSelected.filter(item=>item.claimstatus=='New' || item.claimstatus=='Reject' || item.claimstatus=='Completed').map(item=>item.claimnum.toString()).join(', ');
    },
    editItem(item) {
      this.$router.push({ name: 'ClaimEdit', params: item })
    },
    makeReimbursementList(){
      if(!this.checkError()) {
        if(this.dataSelected.length==0) this.dialogMessage='No Claims selected';
        else this.dialogMessage='The following Claims cannot be reimbursed:  ' + this.checkClaims();
        this.dialogAlert=true; 
        return;
      }
      let claims = Object.assign([], this.dataSelected);
      let json = {claims: claims, isClaims: true};
      this.$router.push({ name: 'ReimbursementAdd', params: json });
    },
    printItem(item) {
      let params = Object.assign({}, item);
      params.isFromAdm = true;
      this.$router.push({ name: 'ClaimPrint', params: params })
    },
    viewItem(item) {
      let params = Object.assign({}, item);
      params.isFromAdm = true;
      this.$router.push({ name: 'ClaimView', params: params })
    },
    async deleteItem(item) {
      let result = await this.deleteClaimRequest({_id: item._id});
      let index = this.data_claims.map(claim=>claim._id).indexOf(result._id);
      this.data_claims.splice(index, 1);
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deleteclaim = {
        _id: item._id,
        claimnum: item.claimnum,
        claimname: item.claimname,
      }
    },
    editClaimStatusDialog(item) {
      this.claimstatus = {claimid: item._id};
      this.showEditDialog = true;
    },
    async editClaimStatus() {
      if(!this.checkError1()){return}
      this.showEditDialog = false;
      let result = await await this.updateClaimStatusRequest(this.claimstatus);
      let index = this.data_claims.findIndex((claim) => claim._id == result._id);
      this.data_claims.splice(index, 1, result);
      
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
